import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import styled from "styled-components";

//style
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 20px;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
  text-align: start;

  color: var(--text-color, #ffffff);
  font-family: "Neue Machina";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
  width: 80%;
  white-space: nowrap;
  @media (max-width: 950px) {
    width: 95%;
  }
  form {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    button {
      width: fit-content;
      background-color: #000000;
      color: white;
      border: none;
      border-radius: 10px;
      padding: 10px 20px;
      width: 100%;
      font-family: "Poppins", sans-serif;
      &:hover {
        cursor: pointer;
      }
      &:active {
        opacity: 0.7;
      }
    }
    input {
      width: 100%;
      height: 40px;
      border: none;
      border-bottom: 1px solid black;
      background: inherit;
      color: black;
      box-sizing: border-box;
      border-radius: 0; /* Remove Safari default border radius */
      &::placeholder {
        color: #000000;
      }
      &:focus {
        outline: none;
      }
    }
    textarea {
      height: 100px;
      padding: 10px;
      margin-bottom: 20px;
      border: none;
      border-bottom: 1px solid black;
      background-color: inherit;
      border-radius: 0;
      &:focus {
        outline: none;
      }
      &::placeholder {
        color: #000000;
      }
    }
    label {
      font-family: "Neue Machina";
      color: rgb(0, 0, 0);
      font-size: 16px;
      font-weight: 500;
    }
  }
`;

export const ContactUs = () => {
  const form = useRef();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_wweiofw", "template_u9bb5qp", form.current, {
        publicKey: "-0GjtdOfIEC3lqdTB",
      })
      .then(
        () => {
          setName("");
          setEmail("");
          setMessage("");
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <Container>
      <form ref={form} onSubmit={sendEmail}>
        <label htmlFor="user_name">Full Name</label>
        <input
          type="text"
          name="user_name"
          placeholder="ex.Idris"
          value={name}
        />
        <label htmlFor="user_email">Email Address</label>
        <input
          type="email"
          name="user_email"
          placeholder="example@gmail.com"
          value={email}
        />
        <label htmlFor="message">Your Message</label>
        <textarea name="message" placeholder="ex.let's work" value={message} />
        <button type="submit" value="Send">
          Send Me Message
        </button>
      </form>
    </Container>
  );
};
